import { OnInit, Renderer2 } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/security/auth.service';
import { PolicyService } from 'app/services/policy-service';
import { EventService } from 'app/services/event-service';
import { DasLexService } from 'app/services/daslex-service';
import { ChatService } from 'app/services/chat-service';
import { ClaimService } from 'app/services/claim-service';
import { CommonsText } from 'app/commons/CommonsText';
import { CommonsUtils } from 'app/commons/CommonsUtils';
import { BlogJuridicoService } from 'app/shared/services/wordpress/blog-juridico.service';
var MainPageComponent = /** @class */ (function () {
    function MainPageComponent(policyService, authService, eventService, dasLexService, blogJuridicoService, chatService, claimService, toastr, renderer, document) {
        this.policyService = policyService;
        this.authService = authService;
        this.eventService = eventService;
        this.dasLexService = dasLexService;
        this.blogJuridicoService = blogJuridicoService;
        this.chatService = chatService;
        this.claimService = claimService;
        this.toastr = toastr;
        this.renderer = renderer;
        this.document = document;
        this.userName = '';
        this.allQuickActions = [
            { iconKey: 'chat', title: 'Chatea con un abogado', desc: 'Resuelve tus dudas legales con especialistas', link: '/#' },
            { iconKey: 'add', title: 'Abrir expediente', desc: 'Indica lo ocurrido y completa tus datos', link: '/events/register' },
            { iconKey: 'click', title: 'Consulta tus expedientes', desc: 'Sigue su estado y evolución', link: '/expedientes' },
            { iconKey: 'shield', title: 'Consulta tus seguros', desc: 'Revisa tus pólizas y coberturas', link: '/insurances' }
        ];
        // El catálogo se resuelve una sola vez: otherProducs() crea objetos nuevos en cada llamada y
        // desde un getter haría que *ngFor volviese a pintar las tarjetas en cada ciclo de detección.
        this.allOtherInsurances = CommonsUtils.otherProducs();
        this.expedientes = [];
        this.consultasLegales = [];
        this.productosActivos = [];
        this.loadingExpedientes = false;
        this.loadingConsultas = false;
        this.loadingProductos = false;
        this.showCategoria = false;
        this.showDirectAreas = true;
        this.hasLegalPolicies = false;
        // "Mis beneficios" solo para tomadores de PP09/PP11/DJ13/DJ29 (ver PolicyService).
        this.showBenefits = false;
    }
    Object.defineProperty(MainPageComponent.prototype, "quickActions", {
        // El chat con abogado solo se ofrece a quien tiene una DJ29 en vigor (hasLegalPolicies).
        // Se identifica por iconKey, igual que hace quick-actions al abrir el modal: por título
        // dependería del copy, y un cambio de texto colaría la acción a quien no le corresponde.
        get: function () {
            return this.hasLegalPolicies
                ? this.allQuickActions
                : this.allQuickActions.filter(function (action) { return action.iconKey !== 'chat'; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainPageComponent.prototype, "otherInsurances", {
        /**
         * No se ofrece el Abogado de Familia a quien ya tiene contratada una póliza de Asistencia
         * Jurídica Familiar (DJ29 en vigor, hasLegalPolicies). Se filtra por id y no por título,
         * por el mismo motivo que quickActions usa iconKey.
         */
        get: function () {
            return this.hasLegalPolicies
                ? this.allOtherInsurances.filter(function (seguro) { return seguro.id !== CommonsUtils.FAMILY_LAWYER_ID; })
                : this.allOtherInsurances;
        },
        enumerable: true,
        configurable: true
    });
    MainPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        var user = this.authService.getUser();
        if (user && user.name) {
            this.userName = user.name.toString();
        }
        this.showDirectAreas = this.authService.getSelectedEntity() === 'ONLYGAL';
        if (this.categorias === undefined) {
            // Único punto de escritura en localStorage: persistimos las categorías
            // cargadas en memoria (desde WordPress al arrancar la app) una vez la carga
            // ha terminado. El resto de pantallas las leen de localStorage sin volver a
            // consultar WordPress. showCategoria habilita <app-articles> DESPUÉS de la
            // escritura para que su ngOnInit lea ya el localStorage relleno.
            this.blogJuridicoService.guardarCategoriasEnStorage().then(function () {
                _this.categorias = _this.blogJuridicoService.getCategoriasCompletas();
                _this.showCategoria = true;
            });
        }
        this.loadCurrentPolicies();
        // Los expedientes no son exclusivos del area directa: en reaseguro tambien los hay
        // (el menu lateral los ofrece como "Partes") y la seccion se pinta siempre.
        this.loadExpedientes();
        if (this.showDirectAreas) {
            this.loadLegalPolicies();
            this.policyService.hasBenefitProducts()
                .then(function (has) { _this.showBenefits = has; });
        }
    };
    MainPageComponent.prototype.loadLegalPolicies = function () {
        var _this = this;
        this.policyService.hasLegalAssistanceProduct()
            .then(function (has) {
            _this.hasLegalPolicies = has;
            if (_this.hasLegalPolicies) {
                _this.chatService.ensureWidgetLoaded();
                _this.loadConsultasLegales();
            }
        });
    };
    MainPageComponent.prototype.loadExpedientes = function () {
        var _this = this;
        this.loadingExpedientes = true;
        this.eventService.getOpenEvents()
            .then(function (success) {
            var list = (success && success.response) ? success.response : [];
            _this.expedientes = list.map(function (e) { return ({
                titulo: e.versionType || '',
                estado: e.eventStatus || '',
                polizaNumero: e.policyNumber || e.idRea || '',
                expedienteNumero: (e.eventNumber || '').toString(),
                eventYear: (e.eventYear || '').toString(),
                fechaOcurrencia: _this.formatDay(e.eventEndDate),
                esAseguradoEnExpediente: e.isInsuredInEvent === true
            }); });
            _this.loadingExpedientes = false;
        })
            .catch(function () {
            _this.expedientes = [];
            _this.loadingExpedientes = false;
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_PARTES, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                timeOut: 5000
            });
        });
    };
    /**
     * Carga (máximo 3, mediante paginación) las consultas de siniestros del usuario logado
     * desde el nuevo servicio de consultas (Innova).
     */
    MainPageComponent.prototype.loadConsultasLegales = function () {
        var _this = this;
        this.loadingConsultas = true;
        this.claimService.list(0, 3)
            .then(function (page) {
            var list = (page && page.content) ? page.content : [];
            _this.consultasLegales = list.map(function (c) { return ({
                titulo: [c.queryTypeDescription, c.querySubtypeDescription].filter(Boolean).join(': '),
                detalle: c.description || '',
                fechaApertura: c.date || '',
                tramitador: c.handlerName || '',
                estado: ''
            }); });
            _this.loadingConsultas = false;
        })
            .catch(function () {
            _this.consultasLegales = [];
            _this.loadingConsultas = false;
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_CONSULTAS, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                timeOut: 5000
            });
        });
    };
    /**
     *  - Calcula y persiste la relación del cliente (TOMA/ASEG).
     *  - Si es área directa (ONLYGAL), construye la lista de productos activos.
     */
    MainPageComponent.prototype.loadCurrentPolicies = function () {
        var _this = this;
        if (this.showDirectAreas) {
            this.loadingProductos = true;
        }
        this.policyService.getCurrent()
            .then(function (success) {
            var list = (success && success.response) ? success.response : [];
            if (_this.showDirectAreas) {
                _this.productosActivos = list.map(function (p) { return ({
                    nombre: p.product || '',
                    poliza: p.number || '',
                    estado: _this.normaliseEstado(p.status),
                    vigencia: _this.composeVigencia(p.startDate, p.endDate),
                    branchType: p.branchType || ''
                }); });
                _this.loadingProductos = false;
            }
        })
            .catch(function () {
            _this.productosActivos = [];
            _this.loadingProductos = false;
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_POLIZAS, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                timeOut: 5000
            });
        });
    };
    /*
    private composeLetrado(letrado: any): string {
        if (!letrado) {
            return '';
        }
        const nombre = letrado.nombre || '';
        const apellidos = letrado.apellidos || '';
        return (nombre + ' ' + apellidos).trim();
    }
    */
    /** Normaliza el estado de la póliza: sin valor => "Activo"; en otro caso, capitalizado. */
    MainPageComponent.prototype.normaliseEstado = function (raw) {
        if (!raw) {
            return 'Activo';
        }
        var str = raw.toString();
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };
    MainPageComponent.prototype.composeVigencia = function (startDate, endDate) {
        var start = this.formatDay(startDate);
        var end = this.formatDay(endDate);
        if (!start && !end) {
            return '';
        }
        return 'Del ' + start + ' a ' + end;
    };
    MainPageComponent.prototype.formatDay = function (value) {
        if (!value) {
            return '';
        }
        var str = value.toString();
        var isoMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (isoMatch) {
            return isoMatch[3] + '/' + isoMatch[2] + '/' + isoMatch[1];
        }
        var date = new Date(str);
        if (isNaN(date.getTime())) {
            return str;
        }
        var pad = function (n) { return (n < 10 ? '0' + n : '' + n); };
        return pad(date.getDate()) + '/' + pad(date.getMonth() + 1) + '/' + date.getFullYear();
    };
    return MainPageComponent;
}());
export { MainPageComponent };
